<template>
    <span
        title="紧凑模式"
        class="form-minimize-btn">
        <el-checkbox v-model="formInlineData" style="position: relative;top: -5px;">紧凑</el-checkbox>
    </span>
</template>

<script>
export default {
    name: 'FormInlineMode',

    props: ['value'],

    data() {
        return {
            formInlineData: null
        }
    },

    watch: {
        value() {
            this.formInlineData = this.value;
        },

        formInlineData() {
            this.$emit('input', this.formInlineData);
        }
    },

    mounted() {
        this.formInlineData = this.value;
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/FormInlineMode.vue